import { Flex, Table, Tbody, Th, Thead, Tr } from '@chakra-ui/react';
import { Modal, ModalBody, ModalHeader, Button, Text } from 'components/UI';
import { LinkButton } from 'components/common/Buttons/LinkButton';
import { gradientStyle } from 'constants/theme';
import { IQuoteJson } from 'types';
import QuoteRow from './QuoteRow';

type QuoteModalProps = {
  quote?: IQuoteJson;
  closePopup: () => void;
  quotePdfUrl?: string;
  isOpen: boolean;
};

const QuoteModal = ({ quote, closePopup, quotePdfUrl, isOpen }: QuoteModalProps) => {
  if (!Array.isArray(quote)) return null;

  const [headers, ...rows] = quote;

  const renderFields = rows.map(({ column1, column2 }, i) => (
    <QuoteRow key={column1} column1={column1} column2={column2} version={i % 2} />
  ));

  const { column1, column2 } = headers;

  const renderQuotePdfLink = quotePdfUrl ? (
    <LinkButton
      size="sm"
      href={quotePdfUrl}
      sx={{
        ...gradientStyle,
        _focus: {
          boxShadow: 'none',
        },
        color: 'primaryFontColour.400',
        borderStyle: 'solid',
        w: 250,
      }}
    >
      <Text color="primaryFontColour.400" letterSpacing={2}>
        DOWNLOAD{' '}
        <Text as="span" fontWeight="bold" color="primaryFontColour.400" letterSpacing={2}>
          QUOTE
        </Text>
      </Text>
    </LinkButton>
  ) : null;

  return (
    <Modal
      isOpen={isOpen}
      isCloseButton
      closeOnEsc={false}
      closeOnOverlayClick
      isCentered
      size="xl"
      onClose={closePopup}
    >
      <ModalHeader textAlign="center" fontSize="4xl">
        QUOTE
      </ModalHeader>
      <ModalBody pb={8}>
        <Table mb={8}>
          <Thead>
            <Tr h={30} fontSize={20} pl={6} pr={6} mb={4}>
              <Th textAlign="center">{column1}</Th>
              <Th textAlign="center">{column2}</Th>
            </Tr>
          </Thead>
          <Tbody mb={8} maxH={300} overflowY="auto">
            {renderFields}
          </Tbody>
        </Table>
        <Flex flexDir="row" justifyContent="space-around">
          {renderQuotePdfLink}

          <Button
            sx={{
              ...gradientStyle,
              _focus: {
                boxShadow: 'none',
              },
              color: 'primaryFontColour.400',
              borderStyle: 'solid',
              w: 250,
            }}
            size="sm"
            onClick={closePopup}
          >
            CLOSE
          </Button>
        </Flex>
      </ModalBody>
    </Modal>
  );
};

export default QuoteModal;
